"use client";

import { tagById } from "@/lib/invoice/tags";
import { cx } from "./ui";

export function TagChip({ tag, small, onRemove, count }) {
  if (!tag) return null;
  return (
    <span
      className={cx("inline-flex items-center gap-1 rounded-full font-medium", small ? "px-1.5 py-0 text-[10px]" : "px-2 py-0.5 text-[11px]")}
      style={{ background: `${tag.color}1f`, color: tag.color }}
    >
      {tag.name}
      {count != null && <span className="opacity-70">· {count}</span>}
      {onRemove && (
        <button className="leading-none opacity-70 hover:opacity-100" onClick={onRemove} aria-label={`Remove ${tag.name}`}>
          ×
        </button>
      )}
    </span>
  );
}

export function TagList({ ids = [], tags, small, max = 4 }) {
  const list = ids.map((id) => tagById(tags, id)).filter(Boolean);
  return (
    <span className="inline-flex flex-wrap gap-1">
      {list.slice(0, max).map((t) => <TagChip key={t.id} tag={t} small={small} />)}
      {list.length > max && <span className="text-[10px] text-slate-400">+{list.length - max}</span>}
    </span>
  );
}

// Toggle chips for picking several tags.
export function TagPicker({ value = [], onChange, tags }) {
  const set = new Set(value);
  return (
    <div className="flex flex-wrap gap-1.5">
      {tags.map((t) => {
        const on = set.has(t.id);
        return (
          <button
            type="button"
            key={t.id}
            onClick={() => onChange(on ? value.filter((x) => x !== t.id) : [...value, t.id])}
            className="rounded-full border px-2.5 py-1 text-xs font-medium transition"
            style={on ? { background: t.color, borderColor: t.color, color: "#fff" } : { borderColor: `${t.color}66`, color: t.color }}
          >
            {t.name}
          </button>
        );
      })}
    </div>
  );
}

// Compact single-tag select (for projects and invoice lines).
export function TagSelect({ value, onChange, tags, className, placeholder = "No category" }) {
  const t = tagById(tags, value);
  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className={cx("rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs focus:border-brand-600 focus:outline-none", className)}
      style={t ? { color: t.color, fontWeight: 600 } : undefined}
    >
      <option value="">{placeholder}</option>
      {tags.map((x) => (
        <option key={x.id} value={x.id}>{x.name}</option>
      ))}
    </select>
  );
}
